// import { createSHA256 } from 'hash-wasm';

// export const sha256Hash = () => {
//     const chunkSize = 5 * 1024 * 1024;
//     const fileReader = new FileReader();
//     let hasher = null;

//     function hashChunk(chunk) {
//         return new Promise((resolve, reject) => {
//             fileReader.onload = async (e) => {
//                 const view = new Uint8Array(e.target.result);
//                 hasher.update(view);
//                 resolve();
//             };

//             fileReader.readAsArrayBuffer(chunk);
//         });
//     }

//     const readFile = async (file) => {
//         if (hasher) {
//             hasher.init();
//         } else {
//             hasher = await createSHA256();
//             hasher.init();
//         }

//         const chunkNumber = Math.floor(file.size / chunkSize);

//         for (let i = 0; i <= chunkNumber; i++) {
//             const chunk = file.slice(
//                 chunkSize * i,
//                 Math.min(chunkSize * (i + 1), file.size)
//             );
//             await hashChunk(chunk);
//         }

//         const hash = hasher.digest();
//         return Promise.resolve(hash);
//     }

//     return {
//         readFile
//     }
// }

// export default sha256Hash;
export async function sha256HashFile(file) {
  const chunkSize = 5 * 1024 * 1024; // 5MB
  const chunks = Math.ceil(file.size / chunkSize);
  const hashBuffer = await (async () => {
    const hash = await window.crypto.subtle.digest(
      "SHA-256",
      await (async () => {
        const buffers = [];
        for (let i = 0; i < chunks; i++) {
          const start = i * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          const chunk = file.slice(start, end);
          const buffer = await chunk.arrayBuffer();
          buffers.push(new Uint8Array(buffer));
        }
        // Concatenate all buffers
        const totalLength = buffers.reduce((acc, curr) => acc + curr.length, 0);
        const all = new Uint8Array(totalLength);
        let offset = 0;
        for (const buf of buffers) {
          all.set(buf, offset);
          offset += buf.length;
        }
        return all;
      })()
    );
    return hash;
  })();

  // Convert ArrayBuffer to hex string
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
